import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "text-subtitle-1 font-weight-medium" }
const _hoisted_2 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_3 = { class: "text-body-2 mb-3 break-url" }
const _hoisted_4 = { class: "text-body-2 mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "text-body-2 mb-3"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_7 = { class: "text-caption text-medium-emphasis mb-1" }
const _hoisted_8 = {
  key: 0,
  class: "text-error"
}
const _hoisted_9 = {
  key: 0,
  class: "text-body-2 mb-2"
}
const _hoisted_10 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_11 = { class: "text-body-2" }
const _hoisted_12 = { class: "d-flex flex-wrap ga-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mb-3",
    variant: "outlined"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, { class: "pb-2" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "d-flex align-center flex-wrap ga-2 cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectServer && _ctx.selectServer(...args)))
          }, [
            _createVNode(_component_v_icon, { color: _ctx.statusColor }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.statusIcon), 1)
              ]),
              _: 1
            }, 8, ["color"]),
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.server.displayName), 1),
            (_ctx.showAvailabilityChip)
              ? (_openBlock(), _createBlock(_component_v_chip, {
                  key: 0,
                  size: "small",
                  color: "default",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.installLabel), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              size: "small",
              variant: "text",
              icon: _ctx.expanded ? 'mdi-chevron-up' : 'mdi-chevron-down',
              onClick: _withModifiers(_ctx.toggleExpanded, ["stop"])
            }, null, 8, ["icon", "onClick"])
          ]),
          _createVNode(_component_v_expand_transition, null, {
            default: _withCtx(() => [
              (_ctx.expanded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-1" }, "Server URL", -1)),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.server.url || 'Platform-managed server'), 1),
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-1" }, "Description", -1)),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.server.description || 'No description provided.'), 1),
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-1" }, "Secrets", -1)),
                    (_ctx.showSecretSummary)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.secretSummary), 1))
                      : _createCommentVNode("", true),
                    (_ctx.renderedSecretFields.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (_ctx.saveError)
                            ? (_openBlock(), _createBlock(_component_v_alert, {
                                key: 0,
                                type: "error",
                                density: "compact",
                                variant: "tonal",
                                class: "mb-3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.saveError), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderedSecretFields, (field) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: field.name,
                              class: "mb-3"
                            }, [
                              _createElementVNode("div", _hoisted_7, [
                                _createTextVNode(_toDisplayString(field.label) + " ", 1),
                                (field.required)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "*"))
                                  : _createCommentVNode("", true)
                              ]),
                              (field.description)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(field.description), 1))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_text_field, {
                                modelValue: _ctx.secretValues[field.name],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.secretValues[field.name]) = $event),
                                label: field.label,
                                type: "password",
                                variant: "outlined",
                                density: "compact"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label"])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showExpandedAuthLabel)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-1" }, "OAuth", -1)),
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.authLabel), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_v_btn, {
                        size: "small",
                        variant: "outlined",
                        onClick: _withModifiers(_ctx.selectServer, ["stop"])
                      }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("View Tools")
                        ])),
                        _: 1,
                        __: [2]
                      }, 8, ["onClick"]),
                      (_ctx.server.canConfigure && _ctx.renderedSecretFields.length > 0)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            size: "small",
                            color: "primary",
                            variant: "outlined",
                            loading: _ctx.savingSecrets,
                            onClick: _withModifiers(_ctx.saveSecrets, ["stop"])
                          }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createTextVNode(" Save Secrets ")
                            ])),
                            _: 1,
                            __: [3]
                          }, 8, ["loading", "onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.server.authMode === 'oauth2' && _ctx.server.installed)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            size: "small",
                            color: "primary",
                            variant: "outlined",
                            onClick: _withModifiers(_ctx.openOAuthDialog, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.oauthActionLabel), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.server.canInstall && !_ctx.server.installed)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 2,
                            size: "small",
                            color: "primary",
                            variant: "outlined",
                            onClick: _withModifiers(_ctx.toggleInstalled, ["stop"])
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode(" Install ")
                            ])),
                            _: 1,
                            __: [4]
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.server.canUninstall && _ctx.server.installed && !_ctx.server.enabled)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 3,
                            size: "small",
                            color: "error",
                            variant: "outlined",
                            onClick: _withModifiers(_ctx.toggleInstalled, ["stop"])
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode(" Uninstall ")
                            ])),
                            _: 1,
                            __: [5]
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.server.source === 'external' && _ctx.server.installed)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 4,
                            size: "small",
                            variant: "outlined",
                            onClick: _withModifiers(_ctx.toggleEnabled, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.server.enabled ? 'Disable' : 'Enable'), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin && _ctx.server.source === 'external')
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 5,
                            size: "small",
                            color: "error",
                            variant: "outlined",
                            onClick: _withModifiers(_ctx.deleteSharedServer, ["stop"])
                          }, {
                            default: _withCtx(() => _cache[6] || (_cache[6] = [
                              _createTextVNode(" Delete Shared ")
                            ])),
                            _: 1,
                            __: [6]
                          }, 8, ["onClick"]))
                        : (!_ctx.isAdmin && _ctx.server.source === 'external' && !_ctx.server.installed)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 6,
                              size: "small",
                              color: "warning",
                              variant: "outlined",
                              onClick: _withModifiers(_ctx.requestSharedRemoval, ["stop"])
                            }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode(" Request Removal ")
                              ])),
                              _: 1,
                              __: [7]
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}